<script>
import styled from 'vue-styled-components';

const CookieBannerContainer = styled.div`
  box-sizing: border-box;
  border-top: 4px solid; 
  border-bottom: 4px solid; 
  border-color: ${(props) => props.theme.primaryColor};
  height: 100%;
  padding: 2rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default CookieBannerContainer;
</script>